import styles from './d2c-dashboard.module.scss';
import React, { FC, useEffect, useState } from 'react';
import { useAppDispatch } from 'redux/hooks';
import { usePowerBIApiService } from 'api/providers/AppServiceProvider';
import { setPowerBIResponse } from 'features/powerbi-slice';
import PowerBIEmbedded from 'components/molecules/Custom/PowerBI/PowerBIEmbedded';

import { Container } from '../../atoms/Base/Container/Container';
import { PowerBIResponse, ReportPage } from '../../../models/powerbi';
import { useMsal } from '@azure/msal-react';
import { useScreenDetection } from 'common/helpers/screen-detection';

interface ID2CDashboardProps {
}

const D2CDashboard: FC<ID2CDashboardProps> = () => {
     const { accounts } = useMsal();
    const dispatch = useAppDispatch();
    const powerBIApiService = usePowerBIApiService();
    const { layoutType } = useScreenDetection();
    
    const [isLoadingPowerBI, setIsLoadingPowerBI] = useState<boolean>(true);
    const [isPowerBILoading, setIsPowerBILoading] = useState<boolean>(false);
    const [isRefreshTokenLoading, setIsRefreshTokenLoading] = useState<boolean>(false);
    const [powerBIEmbedded, setPowerBiEmbedded] = useState<any>();
    const [accessToken, setAccessToken] = useState<string>();
    const [embedTokenExpiration, setEmbedTokenExpiration] = useState<string>();
    const [reportPages, setReportPages] = useState<ReportPage[]>([]);

    useEffect(() => {
            if (accounts != null && accounts.length > 0) {
                const urlParams = new URLSearchParams(window.location.search);
                const pageFromUrl = urlParams.get('page');

                powerBIApiService.getPowerBID2CDashboardService(pageFromUrl).then(
                    (response: PowerBIResponse) => {
                        if (response != null) {
                            dispatch(setPowerBIResponse(response));
                            setPowerBiEmbedded(response);
                            setAccessToken(response.embedToken);
                            setEmbedTokenExpiration(response.embedTokenExpiration);
                            
                            if (response.pages) {
                                setReportPages(response.pages);
                            } else {
                                setReportPages([]);
                            }
                            
                            setIsLoadingPowerBI(false);
                            setIsPowerBILoading(true);
                            monitorTokenExpiration(response.embedTokenExpiration);
                        }
                    },
                    (error) => {
                        console.error('PowerBI service error:', error);
                        setIsLoadingPowerBI(false);
                    }
                );
            }
        }, [accounts]);

   useEffect(() => {
        const intervaldata = setInterval(() => {
            if (embedTokenExpiration != null && embedTokenExpiration != '') {
                monitorTokenExpiration(embedTokenExpiration);
            }
        }, 60000);
        
        return () => clearInterval(intervaldata);
    }, [embedTokenExpiration]);
   
    const onHandleRenderedPowerBI = (isclose: boolean) => {
        setIsPowerBILoading(isclose);
    };
   
    const monitorTokenExpiration = (tokenExpiration: string): void => {
        var secondsToExpire = Math.floor((new Date(tokenExpiration).getTime() - new Date().getTime()) / 1000);
        var secondsBeforeExpirationForAutoRefresh = 6 * 60;
   
        if (secondsToExpire < secondsBeforeExpirationForAutoRefresh) {
            setEmbedTokenExpiration('');
            if (!isRefreshTokenLoading) {
                refreshEmbedToken();
            }
        }
    };

    const refreshEmbedToken = async () => {
        setIsRefreshTokenLoading(true);
        powerBIApiService.getEmbeddedToken('D2CDashboard').then(
            (response: PowerBIResponse) => {
                if (response != null) {
                    setAccessToken(response.embedToken);
                    setEmbedTokenExpiration(response.embedTokenExpiration);
                    monitorTokenExpiration(response.embedTokenExpiration);
                    setIsRefreshTokenLoading(false);
                }
            },
            (error) => {
                setIsRefreshTokenLoading(false);
                console.log(error);
            }
        );
    };
 
    return (
        <Container>
			{powerBIEmbedded != null && accessToken != null && (
				<PowerBIEmbedded
					reportClass={styles.report_class}
					embedUrl={powerBIEmbedded.embeddedUrl}
					accessToken={accessToken}
					loading={isPowerBILoading}
					onRenderedPowerBI={onHandleRenderedPowerBI}
					layoutType={layoutType}
					menuName="D2C Dashboard"
				/>
			)}
        </Container>
    );
};

export default D2CDashboard;
